// CommonTimeSelectorInput.jsx
import React, { useEffect, useState } from "react";
import CommonInputContainer from "./CommonInputContainer";

function CommonTimeSelectorInput({
  value = "",
  label,
  placeholder = "HH:MM",
  onChange,
  error,
  className,
}) {
  const [inputValue, setInputValue] = useState(value || "");

  // keep local input in sync with external value
  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const handleChange = (val) => {
    // allow only digits and a single colon; trim extra parts
    let v = (val ?? "").replace(/[^0-9:]/g, "");
    const parts = v.split(":");
    if (parts.length > 2) v = parts.slice(0, 2).join(":");
    setInputValue(v);
  };

  const clampPad = (n, max) => {
    const num = Math.min(Math.max(parseInt(n || "0", 10) || 0, 0), max);
    return num.toString().padStart(2, "0");
  };

  const handleBlur = () => {
    if (!inputValue) {
      onChange && onChange("");
      return;
    }
    const [h, m] = inputValue.split(":");
    const hh = clampPad(h, 23);
    const mm = clampPad(m, 59);
    const formatted = `${hh}:${mm}`;
    setInputValue(formatted);
    onChange && onChange(formatted);
  };

  return (
    <CommonInputContainer
      label={label}
      error={error && !inputValue}
      className={className}
    >
      <div className="relative">
        <input
          type="text"
          inputMode="numeric"
          value={inputValue}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={handleBlur}
          placeholder={placeholder}
          maxLength={5}
          className={`w-full h-12 items-center px-4 pr-10 border ${
            error && !inputValue ? "border-red-600" : "border-[#DBDBDB]"
          } rounded-lg placeholder:text-[#A4B1C1] focus:outline-none`}
        />
        <img
          src="/IconClock2.svg"
          alt=""
          className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 w-4 object-contain"
        />
      </div>
    </CommonInputContainer>
  );
}

export default CommonTimeSelectorInput;
